// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import { LoadableLazy } from '@confluence/loadable';

export type { AnalyticsDialogProps } from './AnalyticsDialog.tsx';

export const LazyAnalyticsDialog = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AnalyticsDialog" */ './AnalyticsDialog.tsx'))
			.AnalyticsDialog,
});
